import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { Controller, useForm } from 'react-hook-form';
import { useAuth } from '../../../../../hooks/useAuth';
import moment from 'moment';

/**
 * 
 * @param {*} props 
 * Props: 
 * - visible
 * - maintenanceLog
 * - onHide
 * - onMaintenanceLogSaved
 * @returns 
 */
function MaintenanceLogReportEditDialog(props) {

  // #region Vars and Consts

  const { user } = useAuth();
  const [isNew, setIsNew] = useState(false);
  const [vehicles, setVehicles] = useState([]);  
  const [serviceTypes, setServiceTypes] = useState([]);  
  const [serviceTypeConcepts, setServiceTypeConcepts] = useState([]);  
  const defaultValues = {
    description: "",
    vehicle: null,
    serviceType: null,
    serviceTypeConcept: null,
    amountWTax: 0,
    notes: '',
    supplier: '',
    dischargeDate: null,
    user: null
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm({ defaultValues });

  // #endregion

  // #region Methods

  const resetForm = () => {
    reset(defaultValues);
  };

  const getVehicles = () => {
    console.group("Get vehicles");
    fetch(`${process.env.REACT_APP_API_URL}/vehicle/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        console.log("Vehicles", data.responseObject);
        if (data.responseCode === 'OK') {
          setVehicles(data.responseObject);
        } else {
          console.warn('Error getting vehicles', data);
        }
        console.groupEnd();
      }, (error) => {
        console.error("Error getting vehicles", error);
        console.groupEnd();
      });
  };  

  const getServiceTypes = () => {
    console.group("Get service types");
    fetch(`${process.env.REACT_APP_API_URL}/serviceType/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        console.log("Service types", data.responseObject);
        if (data.responseCode === 'OK') {
          setServiceTypes(data.responseObject);
        } else {
          console.warn('Error getting service types', data);
        }
        console.groupEnd();
      }, (error) => {
        console.error("Error getting service types", error);
        console.groupEnd();
      });
  };  

  const getServiceTypeConcepts = (serviceTypeId) => {
    console.group("Get service type concepts");
    fetch(`${process.env.REACT_APP_API_URL}/serviceTypeConcept/cmbByServiceType?serviceTypeId=${serviceTypeId}`)
      .then(response => response.json())
      .then(data => {
        console.log("Service type cconcepts", data.responseObject);
        if (data.responseCode === 'OK') {
          setServiceTypeConcepts(data.responseObject);
        } else {
          console.warn('Error getting service type cconcepts', data);
        }
        console.groupEnd();
      }, (error) => {
        console.error("Error getting service type cconcepts", error);
        console.groupEnd();
      });
  };  

  const createMaintenanceLog = (
    vehicleServiceId,
    vehicleId,
    serviceTypeId,
    serviceTypeConceptId,
    amountWTax,
    notes,
    supplier,
    dischargeDate,
    userId
  ) => {
    console.group("Create maintenance log");
    fetch(`${process.env.REACT_APP_API_URL}/vehicleService/save`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        vehicleServiceId,
        vehicleId,
        serviceTypeId,
        serviceTypeConceptId,
        amountWTax,
        notes,
        supplier,
        dischargeDate,
        userId        
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("Maintenance log created");
        props.onMaintenanceLogSaved();
        reset();
      } else {
        console.warn("Error creating maintenance log");
      }
      console.groupEnd();
    }, (error) => {
      console.error("Error creating maintenance log", error);
      console.groupEnd();
    });
  };

  const updateMaintenanceLog = (
    vehicleServiceId,
    vehicleId,
    serviceTypeId,
    serviceTypeConceptId,
    amountWTax,
    notes,
    supplier,
    dischargeDate,
    userId
  ) => {
    console.group("Update maintenance log");
    fetch(`${process.env.REACT_APP_API_URL}/vehicleService/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        vehicleServiceId,
        vehicleId,
        serviceTypeId,
        serviceTypeConceptId,
        amountWTax,
        notes,
        supplier,
        dischargeDate,
        userId
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("Maintenance log updated");
        props.onMaintenanceLogSaved();
        reset();
      } else {
        console.warn("Error updating maintenance log");
      }
      console.groupEnd();
    }, (error) => {
      console.error("Error updating maintenance log", error);
      console.groupEnd();
    });
  };

  // #endregion

  // #region Events

  const onDialogHide = () => {
    if (props.onHide) props.onHide();
  };

  const onFormSubmit = (data) => {    
    if (isNew) {
      createMaintenanceLog(
        0, // vehicleServiceId,
        data.vehicle.vehicleId, // vehicleId,
        data.serviceType.serviceTypeId, // serviceTypeId,
        data.serviceTypeConcept.serviceTypeConceptId, // serviceTypeConceptId,
        data.amountWTax, // amountWTax,
        data.notes, // notes,
        data.supplier, // supplier,
        moment(data.dischargeDate).valueOf(), // dischargeDate,
        user.userId // userId
      );
    } else {
      updateMaintenanceLog(
        props.maintenanceLog.vehicleServiceId, // vehicleServiceId,
        data.vehicle.vehicleId, // vehicleId,
        data.serviceType.serviceTypeId, // serviceTypeId,
        data.serviceTypeConcept.serviceTypeConceptId, // serviceTypeConceptId,
        data.amountWTax, // amountWTax,
        data.notes, // notes,
        data.supplier, // supplier,
        moment(data.dischargeDate).valueOf(), // dischargeDate,
        user.userId // userId
      );      
    }
  };

  useEffect(() => {
    resetForm();    
    getVehicles();
    getServiceTypes();    
    if (props.maintenanceLog) {
      console.log("Vehicle service", props.maintenanceLog);
      setIsNew(false);
      let maintenanceLog = { ...props.maintenanceLog };       
      maintenanceLog.dischargeDate = moment(props.maintenanceLog.dischargeDateL).toDate();            
      reset(maintenanceLog);
      getServiceTypeConcepts(maintenanceLog.serviceType.serviceTypeId);
    } else {      
      setIsNew(true);
    }    
  }, [props.visible, props.maintenanceLog]);

  // #endregion

  // #region Templates

  const getFormErrorMessage = (name) => {
    return errors[name] && (
      <small className="p-error">
        {errors[name].message}
      </small>
    )
  };

  const formTemplate = (
    <>
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="p-fluid"
      >
        
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="vehicle"
              className={classNames({ 'p-error': errors.vehicle })}>
              Vehículo *
            </label>
            <Controller
              name="vehicle"
              control={control}
              rules={{ required: 'El vehículo es requerido.' }}
              render={({ field, fieldState }) => (
                <Dropdown
                  id={field.name}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  options={vehicles}
                  placeholder="Selecciona el vehículo"
                  optionLabel="description"
                  className={classNames({ 'p-invalid': fieldState.invalid })}    
                />
              )}               
            />
            {getFormErrorMessage('vehicle')}
          </Col>
        </Row>

        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="serviceType"
              className={classNames({ 'p-error': errors.serviceType })}>
              Tipo de Servicio *
            </label>
            <Controller
              name="serviceType"
              control={control}
              rules={{ required: 'El Tipo de Servicio es requerido.' }}
              render={({ field, fieldState }) => (
                <Dropdown
                  id={field.name}
                  value={field.value}
                  onChange={(e) => {
                    field.onChange(e.value);
                    getServiceTypeConcepts(e.value.serviceTypeId);
                  }}
                  options={serviceTypes}
                  placeholder="Selecciona el Tipo de Servicio"
                  optionLabel="description"
                  className={classNames({ 'p-invalid': fieldState.invalid })}
                />
              )}
            />
            {getFormErrorMessage('serviceType')}
          </Col>
        </Row>

        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="serviceTypeConcept"
              className={classNames({ 'p-error': errors.serviceTypeConcept })}>
              Concepto de Tipo de Servicio *
            </label>
            <Controller
              name="serviceTypeConcept"
              control={control}
              rules={{ required: 'El Concepto de Tipo de Servicio es requerido.' }}
              render={({ field, fieldState }) => (
                <Dropdown
                  id={field.name}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  options={serviceTypeConcepts}
                  placeholder="Selecciona el Concepto de Tipo de Servicio"
                  optionLabel="description"
                  className={classNames({ 'p-invalid': fieldState.invalid })}
                />
              )}
            />
            {getFormErrorMessage('serviceTypeConcept')}
          </Col>
        </Row>

        <Row>
          <Col className='pt-1' sm={6}>
            <label
              htmlFor="amountWTax"
              className={classNames({ 'p-error': errors.amountWTax })}>
              Costo con IVA *
            </label>
            <Controller
              name="amountWTax"
              control={control}
              rules={{ required: 'El Costo con IVA es requerido.' }}
              render={({ field, fieldState }) => (
                <InputNumber
                  id={field.name}
                  value={field.value}
                  onValueChange={(e) => field.onChange(e)}
                  mode="decimal"
                  minFractionDigits={0}
                  maxFractionDigits={2} 
                  inputClassName={classNames({ 'p-invalid': fieldState.error })}                   
                />
              )} />
            {getFormErrorMessage('amountWTax')}
          </Col>
        </Row>    
        
        <Row>
          <Col className='pt-1' sm={12}>
            <label
              htmlFor="notes"
            >
              Notas
            </label>
            <Controller
              name="notes"
              control={control}              
              render={({ field, fieldState }) => (
                <InputTextarea
                  id={field.name}
                  {...field}
                  maxLength={255}
                  autoFocus                  
                />
              )} />
          </Col>
        </Row>    

        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="supplier"              
            >
              Taller / Técnico / Proveedor
            </label>
            <Controller
              name="supplier"
              control={control}              
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  maxLength={255}
                  autoFocus                  
                />
              )}
            />
          </Col>
        </Row>

        <Row>
          <Col className='pt-1' sm={6}>
            <label
              htmlFor="dischargeDate"
              className={classNames({ 'p-error': errors.dischargeDate })}>
              Fecha de alta *
            </label>
            <Controller
              name="dischargeDate"
              control={control}
              rules={{ required: 'La Fecha de alta es requerida.' }}
              render={({ field, fieldState }) => (
                <DatePicker
                  selected={field.value}
                  onChange={(date) => field.onChange(date)}
                  selectsEnd
                  startDate={field.value}
                  dateFormat="dd/MMM/yyyy"             
                  locale="es"
                  className="w-100 app_datepicker"                   
                />
              )}               
            />
            {getFormErrorMessage('dischargeDate')}
          </Col>
        </Row>   

        <Button
          type="submit"
          label="Guardar"
          className="p-button-raised p-button-sm mt-4"         
        />
      </form>
    </>
  );

  const dialogTemplate = (
    <>
      <Dialog
        header=""
        visible={props.visible}
        onHide={onDialogHide}
        breakpoints={{ '960px': '75vw' }}
        style={{ width: '50vw' }}>
        <h1>Mantenimiento</h1>
        {formTemplate}
      </Dialog>
    </>
  );

  // #endregion

  return (
    <>
      <article>
        {dialogTemplate}
      </article>
    </>
  );
}

export default MaintenanceLogReportEditDialog;